.ADCWrapper
    position: relative
    width: 100%
    min-height: 0
    display: flex
    flex-direction: column
    .ADCTitle
        padding: 0 20px
        font-size: 18px
        font-weight: 700
    .ADCInfo
        padding: 0 20px
        display: flex
        flex-direction: column
        gap: 10px
        justify-content: space-between
        align-items: flex-start
        & > *
            min-width: calc(50% - 5px)

.ADCPickersContainer
    width: 100%
    padding: 0 20px
    display: flex
    flex-direction: column
    justify-content: space-between
    align-items: flex-end
    gap: 20px
    .ADCPickers
        width: 100%
        display: flex
        flex-shrink: 0
        flex-direction: row
        justify-content: space-between
        align-items: center
        gap: 20px
        .ADCPicker
            min-width: 0
            max-width: 100%
            flex: 1
    .ADCButton
        flex-shrink: 0

@media #{$tablet}
    .ADCPickersContainer
        flex-direction: row
        .ADCPickers
            width: calc( 50% - 10px)
        .ADCButton
            width: calc( 50% - 10px)
    .ADCWrapper
        .ADCInfo
            flex-direction: row
            align-items: center
